// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const isVue3 = "true" === 'true';
const isVue2 = !isVue3;

export { isVue2 as a, isVue3 as i };
